import { ChangeDetectionStrategy, Component, inject, isDevMode, OnDestroy, OnInit, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Subscription } from "rxjs";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import ThemeService from "../services/theme.service";

@Component({
    selector: "theme-dev-toggle",
    imports: [MatButtonModule, MatTooltipModule, FaIconComponent],
    templateUrl: "./theme-dev-toggle.component.html",
    styleUrl: "./theme-dev-toggle.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeDevToggleComponent implements OnInit, OnDestroy {
    protected readonly isDev = isDevMode();
    private readonly themeService = inject(ThemeService);

    protected readonly theme = signal("arcus");

    private sub: Subscription;

    ngOnInit() {
        if (!this.isDev) return;
        this.sub = this.themeService.theme$.subscribe((theme) => this.theme.set(theme));
    }

    protected toggle() {
        this.themeService.toggleTheme();
    }

    ngOnDestroy() {
        this.sub?.unsubscribe();
    }
}
